import { defineComponent as _defineComponent } from 'vue'
import ScaleOut from "@/components/scale-out-component.vue";
import BaseDialog from "@/components/base-dialog.vue";
import { ref, computed } from "vue";
import pdf from "vue-pdf";

import { useShowWarningMessage } from "@/composables/use-notifications";
import useDownloadFile from "@/composables/use-download-file";


export default /*#__PURE__*/_defineComponent({
  __name: 'file-previewer-dialog',
  props: {
    isVisible: { type: Boolean },
    filePathUrl: null,
    fileName: null,
    onClose: null
  },
  setup(__props: any) {

const props = __props as {
  isVisible: boolean;
  filePathUrl: string;
  fileName?: string;
  onClose: () => void;
}

const videoRef = ref<HTMLVideoElement | null>(null);



const loading = ref(false);
const isLoading = ref(true);
const activePage = ref(1);
const progress = ref(0);
const totalPages = ref<number | null>(null);
const imageLoading = ref(true);

const pdfKey = ref(0);

const fileType = computed((): "video" | "pdf" | "doc" | "image" | "other" => {
  if (props.filePathUrl) {
    const fileExtension = props.filePathUrl.split(".").pop()?.toLowerCase();

    if (!fileExtension) return "other";

    if (fileExtension === "mp4") {
      return "video";
    } else if (fileExtension === "pdf") {
      return "pdf";
    } else if (
      [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "odt",
        "ods",
        "odp",
        "txt",
      ].includes(fileExtension)
    ) {
      return "doc";
    } else if (
      ["png", "jpg", "jpeg", "gif", "svg", "webp"].includes(fileExtension)
    ) {
      return "image";
    }
  }
  return "other";
});

const downloadProgress = computed(() => {
  return Math.round(progress.value * 100);
});

const closeDialog = () => {
  if (videoRef.value) {
    videoRef.value.pause(); // Pause the video
    videoRef.value.currentTime = 0; // Reset playback position
    videoRef.value.removeAttribute("src"); // Unload video
    videoRef.value.load(); // Refresh the video element
  }

  pdfKey.value++;
  isLoading.value = true;
  imageLoading.value = true;
  activePage.value = 1;
  progress.value = 0;
  loading.value = false;

  props.onClose();
};

const handleFileDownload = () => {
  useDownloadFile(props.filePathUrl, props.fileName);
};

const onPreviewError = () => {
  useShowWarningMessage(
    "loading Failed",
    "Unable to load the selected Document, please try again"
  );
};

const onLoaded = () => {
  isLoading.value = false;
};

const onProgress = (loaded: any) => {
  if (!loaded) return;
  progress.value = loaded;
};

const onNextPage = () => {
  if (activePage.value == totalPages.value) return;
  ++activePage.value;
  window.scrollTo(0, 0);
};

const onPreviousPage = () => {
  if (activePage.value == 1) return;
  --activePage.value;
  window.scrollTo(0, 0);
};

const onPageNumberObtained = (pageNumber: number) => {
  totalPages.value = pageNumber;
};

return { __sfc: true,videoRef, props, loading, isLoading, activePage, progress, totalPages, imageLoading, pdfKey, fileType, downloadProgress, closeDialog, handleFileDownload, onPreviewError, onLoaded, onProgress, onNextPage, onPreviousPage, onPageNumberObtained, ScaleOut, BaseDialog, pdf }
}

})